import { EntityBase } from "./entity-base.model";
import { DetailLedgerKind } from "./detailledgerkind.model";
export class DetailLedger extends EntityBase {
  public DetailLedgerKindId: number;
  public Active: boolean;
  public Code: number;
  public Title: string;
  public Comment: string;
  public DetailLedgerKind: DetailLedgerKind;
  public DetailLedgerTitle: string;
  public DetailLedgerKindCode:number;
}
